import { Link } from "react-router-dom";

const cols = [
  {
    heading: "Product",
    links: [
      { label: "Tools", to: "/tools" },
      { label: "Pricing", to: "/pricing" },
      { label: "Journals", to: "https://journals.casey-tools.com", external: true },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About", to: "#" },
      { label: "Security", to: "/security" },
      { label: "Contact", to: "mailto:info@caseylegaltools.com", external: true },
      { label: "Blog", to: "#" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Terms", to: "/terms" },
      { label: "Privacy", to: "/privacy" },
      { label: "POPIA", to: "/privacy" },
    ],
  },
];

export const Footer = () => (
  <footer className="overflow-hidden bg-forest-deep text-bone">
    <div className="mx-auto max-w-content px-8 pb-8 pt-16">
      <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <div className="font-serif text-[1.4rem] font-extrabold tracking-tight text-bone">
            Casey<span className="align-super text-[0.55em] font-medium">®</span>
          </div>
          <p className="mt-3 max-w-xs text-[0.83rem] leading-relaxed text-bone/60">
            The AI workspace for South African legal practice. Built for attorneys, advocates,
            in-house counsel, and individuals.
          </p>
        </div>
        {cols.map((col) => (
          <div key={col.heading}>
            <div className="label-uppercase mb-3 text-bone/50">{col.heading}</div>
            <ul className="space-y-2">
              {col.links.map((l) => (
                <li key={l.label}>
                  {"external" in l && l.external ? (
                    <a
                      href={l.to}
                      target="_blank"
                      rel="noreferrer"
                      className="text-[0.83rem] text-bone/75 transition-colors hover:text-bone"
                    >
                      {l.label}
                    </a>
                  ) : (
                    <Link to={l.to} className="text-[0.83rem] text-bone/75 transition-colors hover:text-bone">
                      {l.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-bone/10 pt-6 sm:flex-row sm:items-center">
        <p className="text-[0.78rem] text-bone/60">© 2026 CaseyTools.</p>
        <p className="text-[0.78rem] text-bone/40">Johannesburg, South Africa. Proudly South African.</p>
      </div>
    </div>

    {/* The stepped rule — the one African motif (DESIGN.md) — above the giant wordmark. */}
    <svg
      className="mx-auto block pt-4 opacity-30"
      width="180"
      height="14"
      viewBox="0 0 180 14"
      fill="none"
      aria-hidden="true"
    >
      <path d="M0 12 H38 L48 2 H86 L96 12 H134 L144 2 H180" stroke="currentColor" strokeWidth="1" />
    </svg>
    <div
      aria-hidden="true"
      className="select-none text-center font-serif font-extrabold leading-[0.78] text-bone"
      style={{ fontSize: "clamp(6rem, 19vw, 19rem)", letterSpacing: "-0.04em", transform: "translateY(18%)" }}
    >
      CASEY
    </div>
  </footer>
);
